<template>
    <div class="polygon-info">
        Distance: <b>{{$props.selectedUsageDensityPolygon ? `${$props.selectedUsageDensityPolygon.innerBound}km - ${$props.selectedUsageDensityPolygon.outerBound}km` : null}}</b><br>
        Samples: <b>{{$props.selectedUsageDensityPolygon ? $props.selectedUsageDensityPolygon.samples : null}}</b><br>
        Sector: <b>{{$props.selectedUsageDensityPolygon ? $props.selectedUsageDensityPolygon.sectorName || "[NO SECTOR NAME]" : null}}</b>
    </div>
</template>

<script>
export default {
    name: 'UsageDensityPolygonInfoWindow',
    props: ['infoWindowElementCtr', 'map', 'selectedUsageDensityPolygon'],
    components: {

    },
    data: () => ({
        polygonInfoWindow: null,
        polygonInfoWindowOptions: {
            pixelOffset: {
                width: 0,
                height: 0
            },
            closeBoxMargin: "10px 20px 2px 2px",
        },
    }),

    computed: {
    },

    methods: {
    },

    watch: {
    },

    mounted() {
        this.polygonInfoWindow.setPosition(this.$props.selectedUsageDensityPolygon.polygonInfoPosition);
        this.polygonInfoWindow.setContent(this.$el);
        this.polygonInfoWindow.open({map: this.$props.map});
    },

    created() {
        this.polygonInfoWindow = new this.$props.infoWindowElementCtr(this.polygonInfoWindowOptions);
        this.polygonInfoWindow.addListener('close', () => {
            this.$emit('close');
        });
    },

    destroyed() {
        this.polygonInfoWindow.close();
    }

  
};
</script>

<style scoped>
    .polygon-info {
        margin-right: 30px;
    }

</style>
